import useQuery from 'components/useQuery'
import { api } from 'api'
import { useEffect } from 'react'
import { useToast } from '@chakra-ui/react'

export const useUpdateApps = (id) => {
  const toast = useToast()
  const {
    isError,
    isLoading,
    isSuccess,
    request,
    error,
  } = useQuery((data) => api.admin.updateApps(id, data))

  useEffect(() => {
    if (isError) {
      toast({
        title: 'Ошибка',
        description: error.response?.data?.errorText,
        status: 'error',
      })
    }
  }, [isError])

  useEffect(() => {
    if (isSuccess) {
      toast({
        title: 'Готово',
        description: 'Приложение успешно обновлено',
        status: 'success'
      })
    }
  }, [isSuccess])

  return {
    updateApps: request,
    isLoadingUpdate: isLoading
  }
}
